/* eslint-disable eqeqeq */
import React, { Component } from "react";
import API_URL from "../../constants/API_URL";
import {
  Button,
  message,
  Col,
  Row,
  Card,
  Icon,
  Modal,
  Input,
  Form,
  InputNumber,
  Popconfirm,
} from "antd";
import axios from "axios";
import moment from "moment";
// import Loader from 'react-loader-spinner'
import { connect } from "react-redux";
import { posStorageAction } from "../../redux/actions/posStorageAction";
class Payment extends Component {
  constructor() {
    super();
    this.state = {
      paymethods: [],
      order: {},
      totalNet: 0,
      coupon: null,
      discountAmt: 0,
      actualAmt: 0,
      customer_col_points: 0,
      amountPay: "",
      amountPaycheck: "",
      couponNo: null,
      visible: false,
      colModalVisible: false,
      couponBtnLoader: false,
      extraCharge: 0,
      isCashGivenModal: false,
      cashGiven: 0,
      coll_points: 0,
      is_coll_points: false,
      collectionBtnLoader: false,
      orderPaymentsList: [],
    };
  }
  changePayMethod = (e) => {
    if (e === this.state.order.payMethod) {
      message.error("This Payment Method is already selected");
    } else {
      let headers = {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      };
      let authOptions = {
        url: API_URL + "updateSaleOrder",
        method: "POST",
        data: {
          lang: localStorage.getItem("lang"),
          id: this.state.order.id,
          customer: this.state.order.customer,
          payMethod: e,
          flrTable: this.state.order.flrTable,
          orderType: this.state.order.orderType,
          cashier: JSON.parse(localStorage.getItem("userData")).userId,
          noOfGuest: this.state.order.noOfGuest,
        },
        headers,
      };
      axios(authOptions)
        .then((res) => {
          if (res.data.success) {
            message.success(res.data.message);
            this.payMethodsGet();
            this.getOrder();
          }
        })
        .catch((err) => {});
    }
  };
  componentDidMount() {
    this.getCustomer();
    this.getOrderDetails();
    // JS FOR TEXT ANIMATIONS
    var TxtType = function(el, toRotate, period) {
      this.toRotate = toRotate;
      this.el = el;
      this.loopNum = 0;
      this.period = parseInt(period, 10) || 2000;
      this.txt = "";
      this.tick();
      this.isDeleting = false;
    };

    TxtType.prototype.tick = function() {
      var i = this.loopNum % this.toRotate.length;
      var fullTxt = this.toRotate[i];

      if (this.isDeleting) {
        this.txt = fullTxt.substring(0, this.txt.length - 1);
      } else {
        this.txt = fullTxt.substring(0, this.txt.length + 1);
      }

      this.el.innerHTML = '<span class="wrap">' + this.txt + "</span>";

      var that = this;
      var delta = 200 - Math.random() * 100;

      if (this.isDeleting) {
        delta /= 2;
      }

      if (!this.isDeleting && this.txt === fullTxt) {
        delta = this.period;
        this.isDeleting = true;
      } else if (this.isDeleting && this.txt === "") {
        this.isDeleting = false;
        this.loopNum++;
        delta = 500;
      }

      setTimeout(function() {
        that.tick();
      }, delta);
    };

    // window.onload = function() {
    var elements = document.getElementsByClassName("typewrite");
    for (var i = 0; i < elements.length; i++) {
      var toRotate = elements[i].getAttribute("data-type");
      var period = elements[i].getAttribute("data-period");
      if (toRotate) {
        new TxtType(elements[i], JSON.parse(toRotate), period);
      }
    }
    // INJECT CSS
    var css = document.createElement("style");
    css.type = "text/css";
    css.innerHTML = ".typewrite > .wrap { border-right: 0.08em solid #fff}";
    document.body.appendChild(css);
    // };
  }
  getOrderDetails = () => {
    // console.log('pauy', this)
    this.payMethodsGet();
    // this.getOrder()
    let headers = {
      Authorization:
        localStorage.getItem("tokenType") +
        " " +
        localStorage.getItem("accessToken"),
      "Content-Type": "application/json",
    };
    let authOptions = {
      method: "GET",
      url: API_URL + "saleOrderByID",
      params: {
        id: this.props.posStorage.orderId,
        lang: localStorage.getItem("lang"),
      },
      headers,
    };
    axios(authOptions)
      .then((res) => {
        this.getOrderPaymentsList(res.data.object.id);

        this.setState(
          {
            order: res.data.object,
            totalNet: res.data.object.totalNet,
            actualAmt: res.data.object.totalNet,
          },
          () => this.setExtraCharge(),
        );
      })
      .catch((err) => {});
  };
  payMethodsGet = () => {
    let headers = {
      Authorization:
        localStorage.getItem("tokenType") +
        " " +
        localStorage.getItem("accessToken"),
      "Content-Type": "application/json",
    };
    let authOptions = {
      method: "GET",
      url: API_URL + "branchPayMethodsList",
      params: {
        branchId: JSON.parse(localStorage.getItem("userData")).branchId,
        lang: localStorage.getItem("lang"),
      },
      headers,
    };
    axios(authOptions).then((res) => {
      this.setState({ paymethods: res.data });
    });
  };
  setExtraCharge = () => {
    let extraCharge = 0;
    if (this.state.order.chargeType == "P") {
      if (
        this.state.order.minCharge * this.state.order.noOfGuest -
          this.state.totalNet >
        0
      ) {
        extraCharge =
          this.state.order.minCharge * this.state.order.noOfGuest -
          this.state.totalNet;
        let tax = extraCharge * (this.state.order.taxRate / 100);
        extraCharge = parseFloat(extraCharge) + parseFloat(tax);
        extraCharge = parseFloat(extraCharge);
      }
    } else if (this.state.order.chargeType == "T") {
      if (this.state.order.minCharge - this.state.totalNet > 0) {
        extraCharge = this.state.order.minCharge - this.state.totalNet;
        let tax = extraCharge * (this.state.order.taxRate / 100);
        extraCharge = parseFloat(extraCharge) + parseFloat(tax);
        extraCharge = parseFloat(extraCharge);
      }
    }
    let amountPaycheck =
      parseFloat(extraCharge) +
      parseFloat(this.state.totalNet) -
      parseFloat(this.state.order.paidAmt);
    this.setState({ extraCharge: extraCharge, amountPaycheck });
  };
  getOrder = () => {
    let headers = {
      Authorization:
        localStorage.getItem("tokenType") +
        " " +
        localStorage.getItem("accessToken"),
      "Content-Type": "application/json",
    };
    let authOptions = {
      method: "GET",
      url: API_URL + "saleOrderByID",
      params: {
        id: this.props.posStorage.orderId,
        lang: localStorage.getItem("lang"),
      },
      headers,
    };
    axios(authOptions)
      .then((res) => {
        this.setState({ order: res.data.object });
      })
      .catch((err) => {});
  };
  paySaleOrder = () => {
    // return false
    if (JSON.parse(localStorage.getItem("userData")).isCashMgmt) {
      if (this.state.order.isMinCharge) {
        if (this.state.order.chargeType == "P") {
          let amountPaycheck =
            this.state.order.minCharge * this.state.order.noOfGuest;
          if (this.state.totalNet >= amountPaycheck) {
            this.callPaySaleOrderAPI(this.state.totalNet);
          } else {
            this.callPaySaleOrderAPI(amountPaycheck);
          }
        } else if (this.state.order.chargeType == "T") {
          let amountPaycheck = this.state.order.minCharge;
          if (this.state.totalNet >= amountPaycheck) {
            this.callPaySaleOrderAPI(this.state.totalNet);
          } else {
            this.callPaySaleOrderAPI(amountPaycheck);
          }
        }
      } else {
        this.callPaySaleOrderAPI(this.state.totalNet);
      }
    } else {
      message.error("Only Cash Manager Can Pay");
    }
    return false;
  };
  getOrderPaymentsList = async (orderId) => {
    await axios({
      url: API_URL + "paymentLinesByOrder",
      method: "GET",
      params: {
        orderId: orderId,
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    }).then(async (res) => {
      await this.setState({ orderPaymentsList: res.data });
    });
  };
  callPaySaleOrderAPI = (totalNet) => {
    if (
      this.state.amountPaycheck >= 0 &&
      (
        parseFloat(this.state.extraCharge) +
        parseFloat(this.state.actualAmt) -
        (this.state.order.paidAmt + this.state.discountAmt)
      ).toFixed(2) >= parseFloat(this.state.amountPaycheck)
    ) {
      let thiss = this;
      let a = {
        url: API_URL + "paySaleOrder",
        method: "POST",
        data: {
          saleOrderId: thiss.props.state.orderById.id,
          lang: localStorage.getItem("lang"),
          cashier: JSON.parse(localStorage.getItem("userData")).userId,
          totalNet: thiss.state.totalNet,
          coupon: thiss.state.coupon,
          discountAmt: thiss.state.discountAmt,
          actualAmt: thiss.state.actualAmt,
          couponNo: thiss.state.couponNo,
          payCash: thiss.state.cashGiven,
          payMethod: thiss.state.order.payMethod,
          paymentAmt: thiss.state.amountPaycheck,
          isColPointUsed: this.state.isColPointUsed,
          collectPoints: parseInt(this.state.coll_points),
        },
        headers: {
          Authorization:
            localStorage.getItem("tokenType") +
            " " +
            localStorage.getItem("accessToken"),
          "Content-Type": "application/json",
        },
      };
      axios(a).then(async (res) => {
        if (res.data.success) {
          await this.getOrderDetails();
          this.setState({ amountPay: 0, cashGiven: 0 });
          message.success(res.data.message);
          await this.getOrderPaymentsList(this.state.order.id);
          if (res.data.object.status.toUpperCase() == "P") {
            let cashPaidAmount = 0;
            if (
              this.state.paymethods.filter(
                (item) => item.name.toLowerCase() == "cash",
              ).length > 0
            ) {
              if (
                this.state.orderPaymentsList.filter(
                  (i) =>
                    i.payMethod ===
                    this.state.paymethods.filter(
                      (item) => item.name.toLowerCase() == "cash",
                    )[0].id,
                ).length > 0
              ) {
                cashPaidAmount = this.state.orderPaymentsList.filter(
                  (i) =>
                    i.payMethod ===
                    this.state.paymethods.filter(
                      (item) => item.name.toLowerCase() == "cash",
                    )[0].id,
                )[0].paymentAmt;
              }
            }
            await thiss.props.printCall(
              parseFloat(this.state.order.paidAmt) +
                parseFloat(this.state.amountPaycheck),
              cashPaidAmount,
            );
          }
        } else if (!res.data.success) {
          message.error(res.data.message);
        }
      });
    } else {
      message.error("Pay amount is more than the Order Amount");
    }
  };
  calculatorFunctioncashGiven = (e) => {
    let cashGiven = this.state.cashGiven;
    if (e != "b" && e != "c" && e != "e" && e != ".") {
      cashGiven = cashGiven + e.toString();
      this.setState({
        cashGiven: parseFloat(cashGiven),
      });
    } else if (
      e == "b" &&
      this.state.cashGiven != 0 &&
      this.state.cashGiven != ""
    ) {
      cashGiven = cashGiven.toString();
      if (cashGiven.length == 1) {
        cashGiven = 0;
        this.setState({
          cashGiven: parseFloat(cashGiven),
        });
      } else {
        cashGiven = cashGiven.substring(0, cashGiven.length - 1);
        this.setState({
          cashGiven: parseFloat(cashGiven),
        });
      }
    } else if (e == "c") {
      cashGiven = 0;
      this.setState({
        cashGiven: parseFloat(cashGiven),
      });
    } else if (e == ".") {
      if (cashGiven == 0) {
        cashGiven = "0.";
        this.setState({
          cashGiven: cashGiven,
        });
      } else {
        cashGiven = cashGiven + ".";
        this.setState({
          cashGiven: cashGiven,
        });
      }
    } else if (e == "e") {
      if (
        this.state.paymethods.filter(
          (item) => item.id === this.state.order.payMethod,
        ).length > 0
      ) {
        if (
          this.state.paymethods
            .filter((item) => item.id === this.state.order.payMethod)[0]
            .name.toLowerCase() === "cash"
        ) {
          this.openCashGivenModal();
        } else {
          // this.paySaleOrder()
        }
      } else {
        message.error("please select payment method");
      }
    }
  };
  calculatorCollectionPoints = (e) => {
    let cashGiven = this.props.form.getFieldValue("collectPoints");
    if (e != "b" && e != "c" && e != "e" && e != ".") {
      cashGiven = cashGiven + e.toString();
      this.props.form.setFieldsValue({
        collectPoints: parseFloat(cashGiven),
      });
    } else if (
      e == "b" &&
      this.props.form.getFieldValue("collectPoints") != 0 &&
      this.props.form.getFieldValue("collectPoints") != ""
    ) {
      cashGiven = cashGiven.toString();
      if (cashGiven.length == 1) {
        cashGiven = 0;
        this.props.form.setFieldsValue({
          collectPoints: parseFloat(cashGiven),
        });
      } else {
        cashGiven = cashGiven.substring(0, cashGiven.length - 1);
        this.props.form.setFieldsValue({
          collectPoints: parseFloat(cashGiven),
        });
      }
    } else if (e == "c") {
      cashGiven = 0;
      this.props.form.setFieldsValue({
        collectPoints: parseFloat(cashGiven),
      });
    } else if (e == ".") {
      if (this.state.cashGiven == 0) {
        cashGiven = "0.";
        this.props.form.setFieldsValue({
          collectPoints: parseFloat(cashGiven),
        });
      } else {
        this.props.form.setFieldsValue({
          collectPoints: parseFloat(cashGiven),
        });
      }
    }
    // else if (e == 'e') {
    //     if (this.state.paymethods.filter(item => item.id === this.state.order.payMethod).length > 0) {
    //         if (this.state.paymethods.filter(item => item.id === this.state.order.payMethod)[0].name.toLowerCase() === 'cash') {
    //             this.openCashGivenModal()
    //         } else {
    //             // this.paySaleOrder()
    //         }

    //     } else {
    //         message.error("please select payment method")
    //     }
    // }
  };
  openCashGivenModal = () => {
    this.setState({ isCashGivenModal: true });
    document.getElementById("root").classList.add("blurClass");
  };
  calculatorFunction = (e) => {
    let amountPay = this.state.amountPay;

    if (e != "b" && e != "c" && e != "e" && e != ".") {
      if (e == 0 || amountPay[amountPay.length - 1]) {
        amountPay = amountPay + e.toString();
        this.setState({
          amountPay: amountPay,
          amountPaycheck: amountPay,
        });
      } else {
        amountPay = amountPay + e.toString();
        this.setState({
          amountPay: parseFloat(amountPay),
          amountPaycheck: parseFloat(amountPay),
        });
      }
    } else if (
      e == "b" &&
      this.state.amountPay != 0 &&
      this.state.amountPay != ""
    ) {
      amountPay = amountPay.toString();
      if (amountPay.length == 1) {
        amountPay = 0;
        this.setState({
          amountPay: parseFloat(amountPay),
          amountPaycheck: parseFloat(amountPay),
        });
      } else {
        amountPay = amountPay.substring(0, amountPay.length - 1);
        this.setState({
          amountPay: parseFloat(amountPay),
          amountPaycheck: parseFloat(amountPay),
        });
      }
    } else if (e == "c") {
      amountPay = 0;
      this.setState({
        amountPay: parseFloat(amountPay),
        amountPaycheck: parseFloat(amountPay),
      });
    } else if (e == ".") {
      if (this.state.amountPay == 0) {
        amountPay = "0.";
        this.setState({
          amountPay: amountPay,
          amountPaycheck: amountPay,
        });
      } else {
        amountPay = amountPay + ".";
        this.setState({
          amountPay: amountPay,
          amountPaycheck: amountPay,
        });
      }
    } else if (e == "e") {
      // check

      if (
        this.state.paymethods.filter(
          (item) => item.id === this.state.order.payMethod,
        ).length > 0
      ) {
        if (
          this.state.paymethods
            .filter((item) => item.id === this.state.order.payMethod)[0]
            .name.toLowerCase() === "cash"
        ) {
          if (
            this.state.amountPaycheck > 0 &&
            (
              parseFloat(this.state.extraCharge) +
              parseFloat(this.state.totalNet) -
              this.state.order.paidAmt
            ).toFixed(2) >= parseFloat(this.state.amountPaycheck)
          ) {
            this.openCashGivenModal();
            console.log("payCash", this.state.payCash);
            console.log("amountPay", this.state.amountPay);
            console.log("amountPaycheck", this.state.amountPaycheck);
            console.log("actualAmt", this.state.actualAmt);
          } else {
            let amountPay = (
              parseFloat(this.state.extraCharge) +
              parseFloat(this.state.totalNet) -
              this.state.order.paidAmt
            ).toFixed(2);
            let payCash = this.state.amountPaycheck;
            let cashGiven = this.state.amountPaycheck;
            let amountPaycheck = amountPay;
            this.setState(
              { payCash, cashGiven, amountPay, amountPaycheck },
              () => {
                console.log(
                  "remaining",
                  (
                    parseFloat(this.state.extraCharge) +
                    parseFloat(this.state.totalNet) -
                    this.state.order.paidAmt
                  ).toFixed(2),
                );
                console.log("payCash", this.state.payCash);
                console.log("amountPay", this.state.amountPay);
                console.log("amountPaycheck", this.state.amountPaycheck);
                console.log("cashGiven", this.state.cashGiven);
                this.paySaleOrder();
              },
            );

            // amountPay 20
            // Payment.js:514 amountPaycheck 20
            // Payment.js:515 actualAmt 21

            // message.error("Pay amount is more than the Order Amount")
          }
        } else {
          // console.log('payCash',this.state.payCash)
          // console.log('amountPay',this.state.amountPay)
          // console.log('amountPaycheck',this.state.amountPaycheck)
          // console.log('actualAmt',this.state.actualAmt)
          this.paySaleOrder();
        }
      } else {
        message.error("please select payment method");
      }
    }
  };
  cashGivenModalHandler = (e) => {
    if (this.state.cashGiven >= this.state.amountPaycheck) {
      this.paySaleOrder();
      this.setState({ isCashGivenModal: false });
      document.getElementById("root").classList.remove("blurClass");
    } else {
      message.error("cash given by customer should not less than pay amount");
    }
  };
  getCustomer = () => {
    let accessToken = localStorage.getItem("accessToken");
    let lang = localStorage.getItem("lang");
    let tokenType = localStorage.getItem("tokenType");
    axios({
      method: "GET",
      url: API_URL + "customerByID",
      params: {
        id: this.props.posStorage.customer,
        lang: lang,
      },
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
    }).then((res) => {
      if (res.data.success) {
        if (res.data.object.name != "Walk In Customer") {
          this.setState({ customer_col_points: res.data.object.collectPoints });
        } else {
          this.setState({ customer_col_points: 0 });
        }
      }
    });
  };
  opencollectionModal = () => {
    let accessToken = localStorage.getItem("accessToken");
    let lang = localStorage.getItem("lang");
    let tokenType = localStorage.getItem("tokenType");
    axios({
      method: "GET",
      url: API_URL + "customerByID",
      params: {
        id: this.props.posStorage.customer,
        lang: lang,
      },
      headers: {
        Authorization: tokenType + " " + accessToken,
        "Content-Type": "application/json",
      },
    }).then((res) => {
      if (res.data.success) {
        if (res.data.object.name != "Walk In Customer") {
          if (
            res.data.object.collectPoints >=
            JSON.parse(localStorage.getItem("branch_data")).minPoint
          ) {
            this.setState(
              {
                colModalVisible: true,
                customer_col_points: res.data.object.collectPoints,
              },
              () => {
                this.props.form.setFieldsValue({
                  collectPoints: 0,
                });
              },
            );
          } else {
            message.error("Customer Does Not Have Enough Point To Use");
          }
        } else {
          message.error("Not Allowed For Walk In Customers");
        }
      }
    });
  };
  colModalOkHandler = (e) => {
    e.preventDefault();
    let accessToken = localStorage.getItem("accessToken");
    let tokenType = localStorage.getItem("tokenType");
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({ collectionBtnLoader: true });
        if (JSON.parse(localStorage.getItem("branch_data")).isColPointEnable) {
          let discount =
            (values.collectPoints /
              JSON.parse(localStorage.getItem("branch_data")).pointValue) *
            JSON.parse(localStorage.getItem("branch_data")).pointValueAmt;
          let order = { ...this.state.order };
          let actualAmt = order.totalNet;
          let totalNet = actualAmt - discount;
          this.setState({
            collectionBtnLoader: false,
            discountAmt: discount,
            colModalVisible: false,
            totalNet,
            amountPaycheck: totalNet,
            isColPointUsed: true,
            coll_points: values.collectPoints,
            coupon: null,
            couponNo: null,
          });
        } else {
          message.error("Collection Points Are Not Enable For This Branch");
        }
      }
    });
  };
  onOkayHandler = (e) => {
    e.preventDefault();
    let accessToken = localStorage.getItem("accessToken");
    let tokenType = localStorage.getItem("tokenType");
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.setState({ couponBtnLoader: true });
        var authOptions = {
          method: "GET",
          url: API_URL + "couponByCouponNo",
          params: {
            couponNo: values.couponNo,
            clientId: localStorage.getItem("clientId"),
            lang: localStorage.getItem("lang"),
          },
          headers: {
            Authorization: tokenType + " " + accessToken,
            "Content-Type": "application/json",
          },
        };
        axios(authOptions).then((res) => {
          if (res.data.success) {
            if (res.data.object) {
              var fromDate = res.data.object.fromDate;
              var toDate = res.data.object.toDate;
              var from = Date.parse(fromDate);
              var to = Date.parse(toDate);
              var check = Date.parse(moment(new Date()).format("YYYY-MM-DD"));
              if (
                check >= from &&
                check <= to &&
                res.data.object.status == "A" &&
                res.data.object.noOfTimeUse > res.data.object.used
              ) {
                if (localStorage.getItem("coupon")) {
                  let singleCoupon = {
                    orderId: this.state.order.id,
                    coupon: res.data.object,
                  };
                  let coupons = JSON.parse(localStorage.getItem("coupon"));
                  if (
                    coupons.findIndex(
                      (item) => item.orderId == this.state.order.id,
                    ) == -1
                  ) {
                    coupons.push(singleCoupon);
                    localStorage.setItem("coupon", JSON.stringify(coupons));
                  } else {
                    let index = coupons.findIndex(
                      (item) => item.orderId == this.state.order.id,
                    );
                    coupons[index] = singleCoupon;
                    localStorage.setItem("coupon", JSON.stringify(coupons));
                  }
                } else {
                  let couponDetails = [
                    {
                      orderId: this.state.order.id,
                      coupon: res.data.object,
                    },
                  ];
                  localStorage.setItem("coupon", JSON.stringify(couponDetails));
                }
                //

                let order = { ...this.state.order };
                if (res.data.object.discountType == "P") {
                  let actualAmt = order.totalNet;
                  let discountAmt =
                    (order.totalNet * res.data.object.discountPtg) / 100;
                  let totalNet = actualAmt - discountAmt;
                  this.setState({
                    coupon: res.data.object.id,
                    visible: false,
                    totalNet,
                    coll_points: 0,
                    isColPointUsed: false,
                    discountAmt,
                    actualAmt,
                    amountPaycheck: totalNet,
                    couponNo: values.couponNo,
                    couponBtnLoader: false,
                  });
                } else if (res.data.object.discountType == "A") {
                  let totalNet = order.totalNet - res.data.object.discountAmt;
                  let discountAmt = res.data.object.discountAmt;
                  let actualAmt = order.totalNet;
                  if (actualAmt >= discountAmt) {
                    this.setState({
                      coupon: res.data.object.id,
                      visible: false,
                      totalNet,
                      coll_points: 0,
                      isColPointUsed: false,
                      discountAmt,
                      actualAmt,
                      amountPaycheck: totalNet,
                      couponNo: values.couponNo,
                      couponBtnLoader: false,
                    });
                  } else {
                    message.error(
                      "Your Order Amount Is less than Required Amount",
                    );
                    this.setState({ couponBtnLoader: false });
                  }
                }
              } else {
                this.setState({ couponBtnLoader: false });
                message.error(
                  "You Have Entered A Expired Token Or Token Is alredy used",
                );
              }
            } else {
              this.setState({ couponBtnLoader: false });
              message.error("Invalid Coupon!");
            }
          } else {
            this.setState({ couponBtnLoader: false });
            message.error(res.data.message);
          }
        });
      }
    });
  };
  deletePaymentByOrder = (item) => {
    axios({
      url: API_URL + "deletePaymentLine",
      method: "POST",
      data: {
        id: item.id,
        lang: localStorage.getItem("lang"),
      },
      headers: {
        Authorization:
          localStorage.getItem("tokenType") +
          " " +
          localStorage.getItem("accessToken"),
        "Content-Type": "application/json",
      },
    }).then((res) => {
      if (res.data.success) {
        message.success(res.data.message);
        this.getOrderPaymentsList(this.state.order.id);
        this.getOrderDetails();
      } else {
        message.error(res.data.message);
      }
    });
  };
  render() {
    const {
      form: { getFieldDecorator },
      lang: { PAYMENT_SCREEN },
    } = this.props;
    console.log(PAYMENT_SCREEN);
    return (
      <React.Fragment>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Button className="backButton" onClick={this.props.onPaymentSelect}>
            {PAYMENT_SCREEN.BUTTONS.BACK}
          </Button>
          <p style={{ fontWeight: "700", fontSize: "24px" }}>
            {PAYMENT_SCREEN.BUTTONS.PAGE_TITLE}
          </p>
          <Button
            className="payButton"
            onClick={() => {
              if (
                this.state.paymethods.filter(
                  (item) => item.id === this.state.order.payMethod,
                ).length > 0
              ) {
                if (
                  this.state.paymethods
                    .filter((item) => item.id === this.state.order.payMethod)[0]
                    .name.toLowerCase() === "cash"
                ) {
                  this.openCashGivenModal();
                } else {
                  this.paySaleOrder();
                }
              } else {
                message.error(PAYMENT_SCREEN.MESSAGES.SELECT_PAY_METHD);
              }
            }}
          >
            {PAYMENT_SCREEN.BUTTONS.PAY}
          </Button>
        </div>
        <Row style={{ marginTop: "30px" }} gutter={48}>
          <Col span={8}>
            <p className="col_point_show_payment">
              {" "}
              {PAYMENT_SCREEN.LABELS.COLL_POINTS}:{" "}
              {this.state.customer_col_points}
            </p>
            <Card
              className="paymenListCardInPOS"
              title={
                <h2 style={{ textAlign: "center" }}>
                  {PAYMENT_SCREEN.LABELS.PAYMENTS}
                </h2>
              }
            >
              <table style={{ width: "100%" }}>
                <thead>
                  <tr className="paymentsListTRHead">
                    <th>{PAYMENT_SCREEN.LABELS.PAY_MTHD_NAME}</th>
                    <th>{PAYMENT_SCREEN.LABELS.AMOUNT}</th>
                    <th>{PAYMENT_SCREEN.LABELS.ACTION}</th>
                  </tr>
                </thead>

                <tbody>
                  {this.state.orderPaymentsList.length > 0 &&
                    this.state.paymethods.length > 0 &&
                    this.state.orderPaymentsList.map((item) => (
                      <>
                        <tr className="paymentsListTR">
                          <td style={{ paddingLeft: "10px" }}>
                            {this.state.paymethods.filter(
                              (i) => i.id === item.payMethod,
                            ).length > 0 &&
                              this.state.paymethods.filter(
                                (i) => i.id === item.payMethod,
                              )[0].name}
                          </td>
                          <td>{item.paymentAmt}</td>
                          <td>
                            <Popconfirm
                              title="Are you sure delete this payment?"
                              onConfirm={() => this.deletePaymentByOrder(item)}
                              okText="Confirm"
                              cancelText="Cancel"
                            >
                              <Icon
                                className="paymentDeleteIcon"
                                type="delete"
                                style={{ fontSize: "16px", color: "#CC1601" }}
                                theme="outlined"
                              />
                            </Popconfirm>
                          </td>
                        </tr>
                        <div style={{ height: "10px" }}></div>
                      </>
                    ))}
                </tbody>
              </table>
            </Card>

            <Card
              className="pay_mthd_list_pos"
              title={
                <h2 className="glitch side_bar_payscreen-h1">
                  {this.props.lang.BUTTON.PAYMETHOD}
                </h2>
              }
            >
              {this.state.paymethods.length > 0 &&
                this.state.paymethods.map((item, i) => (
                  <p
                    className={
                      this.state.order.payMethod == item.id
                        ? "cash_and_card_selected"
                        : "cash_and_card"
                    }
                    onClick={() =>
                      this.changePayMethod(this.state.paymethods[i].id)
                    }
                    value={item.id}
                    key={item.id}
                  >
                    {item.name}
                  </p>
                ))
              //        {/* <h2 style={{ textAlign:'center'}}>SAR {this.state.order.totalNet}</h2> */}
              }
              {JSON.parse(localStorage.getItem("userData")).isCashMgmt && (
                <>
                  <p
                    className="posButton paymentCusBtn"
                    onClick={() =>
                      !this.state.order.isMinCharge &&
                      this.setState({ visible: true })
                    }
                  >
                    {this.props.lang.BUTTON.USE_COUPON}
                  </p>
                  <p
                    className="posButton paymentCusBtn"
                    onClick={() =>
                      !this.state.order.isMinCharge &&
                      this.opencollectionModal()
                    }
                  >
                    {this.props.lang.BUTTON.USE_COLL_POINTS}
                  </p>
                </>
              )}
            </Card>
          </Col>
          <span className="typewrite top_bar_payscreen-paidAmount">
            <p>
              {PAYMENT_SCREEN.LABELS.PAID} : SAR {this.state.order.paidAmt}
            </p>
            <p>
              {/* <a href=""  style={{fontWeight:'bold', color: '#fff !important'}} className="typewrite" data-period="2000" data-type='[ "Remaining Amount:   "]'>
                            <span className="wrap"></span> 
                        </a>  */}
              {PAYMENT_SCREEN.LABELS.REMAINING}: SAR{" "}
              {(
                parseFloat(this.state.extraCharge) +
                parseFloat(this.state.totalNet) -
                this.state.order.paidAmt
              ).toFixed(2)}
            </p>
          </span>
          <Col span={16}>
            <Card
              className="side_bar_payscreen"
              style={{ minHeight: "70vh", maxHeight: "80vh" }}
              title={
                this.state.order.isMinCharge ? (
                  <div style={{ height: "200%" }}>
                    <h2 className="total_sar">
                      {" "}
                      {PAYMENT_SCREEN.LABELS.TOTAL_AMNT} SAR{" "}
                      {this.state.totalNet.toFixed(2)}
                    </h2>
                    <h2 className="total_sar">
                      {" "}
                      {PAYMENT_SCREEN.LABELS.EXTRA_CHRGES}{" "}
                      {this.state.extraCharge.toFixed(2)}
                    </h2>
                  </div>
                ) : (
                  <div style={{ height: "200%" }}>
                    <h2 className="total_sar">
                      {" "}
                      {PAYMENT_SCREEN.LABELS.TOTAL_AMNT_WITHOUT_TAX} SAR{" "}
                      {this.state.order.totalWithoutTax &&
                        this.state.order.totalWithoutTax.toFixed(2)}
                    </h2>
                    <h2 className="total_sar">
                      {" "}
                      {PAYMENT_SCREEN.LABELS.TOTAL_AMNT} SAR{" "}
                      {this.state.actualAmt.toFixed(2)}
                    </h2>
                    <h2 className="total_sar">
                      {" "}
                      {PAYMENT_SCREEN.LABELS.DISCOUNT} SAR{" "}
                      {this.state.discountAmt.toFixed(2)}
                    </h2>
                    <h2 className="total_sar">
                      {" "}
                      {PAYMENT_SCREEN.LABELS.PAYABLE} SAR{" "}
                      {this.state.totalNet.toFixed(2)}
                    </h2>
                  </div>
                )
              }
            >
              <div style={{ width: "50%", height: "70%", margin: "0 auto" }}>
                <div style={{ width: "100%", height: "100%" }}>
                  <h2 className="amount_Enter"> {this.state.amountPay}</h2>
                </div>
                <div className="calculator_btn_parent_div">
                  <div
                    className="posButton  calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                    }}
                    onClick={() => this.calculatorFunction(1)}
                  >
                    1
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                    }}
                    onClick={() => this.calculatorFunction(2)}
                  >
                    2
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() => this.calculatorFunction(3)}
                  >
                    3
                  </div>
                </div>
                <div className="calculator_btn_parent_div">
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                      borderTop: "none",
                    }}
                    onClick={() => this.calculatorFunction(4)}
                  >
                    4
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      borderTop: "none",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                    }}
                    onClick={() => this.calculatorFunction(5)}
                  >
                    5
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      borderTop: "none",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() => this.calculatorFunction(6)}
                  >
                    6
                  </div>
                </div>
                <div className="calculator_btn_parent_div">
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                      borderTop: "none",
                    }}
                    onClick={() => this.calculatorFunction(7)}
                  >
                    7
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      borderTop: "none",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                    }}
                    onClick={() => this.calculatorFunction(8)}
                  >
                    8
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      borderTop: "none",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() => this.calculatorFunction(9)}
                  >
                    9
                  </div>
                </div>
                <div className="calculator_btn_parent_div">
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                      borderTop: "none",
                    }}
                    onClick={() => this.calculatorFunction("c")}
                  >
                    C
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      borderTop: "none",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                    }}
                    onClick={() => this.calculatorFunction(0)}
                  >
                    0
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      borderTop: "none",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() => this.calculatorFunction("b")}
                  >
                    X
                  </div>
                </div>
                <div className="calculator_btn_parent_div">
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      flexGrow: 1,
                      flexShrink: 2,
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                      borderTop: "none",
                    }}
                    onClick={() => this.calculatorFunction(".")}
                  >
                    .
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      flexGrow: 2,
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                      borderTop: "none",
                    }}
                    onClick={() => this.calculatorFunction("e")}
                  >
                    {PAYMENT_SCREEN.BUTTONS.PAY}
                  </div>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
        {this.state.visible && (
          <Modal
            title={PAYMENT_SCREEN.LABELS.USE_COUPON_MODAL_TITLE}
            className="coupon-modal"
            visible={this.state.visible}
            onCancel={() => this.setState({ visible: false })}
            onOk={() => {
              this.onOkayHandler();
            }}
            footer={false}
          >
            <Form onSubmit={this.onOkayHandler}>
              <Form.Item>
                {getFieldDecorator("couponNo", {
                  rules: [
                    {
                      required: true,
                      message: PAYMENT_SCREEN.MESSAGES.COUPON_NO,
                    },
                  ],
                })(
                  <Input placeholder={PAYMENT_SCREEN.PLACEHOLDERS.COUPON_NO} />,
                )}
              </Form.Item>
              <Form.Item>
                <Button
                  loading={this.state.couponBtnLoader}
                  disabled={this.state.order.isMinCharge}
                  className="signup-form-button btnSpacing"
                  htmlType="submit"
                  size="large"
                  block
                >
                  {this.props.lang.BUTTON.SUBMIT}
                </Button>
              </Form.Item>
            </Form>
          </Modal>
        )}
        {this.state.colModalVisible && (
          <Modal
            title={PAYMENT_SCREEN.LABELS.USE_COLL_POINTS_MODAL_TITLE}
            className="coupon-modal"
            visible={this.state.colModalVisible}
            onCancel={() => this.setState({ colModalVisible: false })}
            onOk={() => {
              this.colModalOkHandler();
            }}
            footer={false}
          >
            <Form onSubmit={this.colModalOkHandler}>
              <Form.Item>
                {getFieldDecorator("collectPoints", {
                  rules: [
                    {
                      required: true,
                      message: PAYMENT_SCREEN.MESSAGES.COLL_POINTS,
                    },
                  ],
                })(
                  <Input
                    placeholder={PAYMENT_SCREEN.PLACEHOLDERS.COLL_POINTS}
                  />,
                )}
              </Form.Item>
            </Form>
            <Card>
              <div style={{ width: "100%", height: "70%", margin: "0 auto" }}>
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div
                    className="posButton  calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                    }}
                    onClick={() => this.calculatorCollectionPoints(1)}
                  >
                    1
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                    }}
                    onClick={() => this.calculatorCollectionPoints(2)}
                  >
                    2
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() => this.calculatorCollectionPoints(3)}
                  >
                    3
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                      borderTop: "none",
                    }}
                    onClick={() => this.calculatorCollectionPoints(4)}
                  >
                    4
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      borderTop: "none",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                    }}
                    onClick={() => this.calculatorCollectionPoints(5)}
                  >
                    5
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      borderTop: "none",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() => this.calculatorCollectionPoints(6)}
                  >
                    6
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                      borderTop: "none",
                    }}
                    onClick={() => this.calculatorCollectionPoints(7)}
                  >
                    7
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      borderTop: "none",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                    }}
                    onClick={() => this.calculatorCollectionPoints(8)}
                  >
                    8
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      borderTop: "none",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() => this.calculatorCollectionPoints(9)}
                  >
                    9
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                      borderTop: "none",
                    }}
                    onClick={() => this.calculatorCollectionPoints("c")}
                  >
                    C
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      borderTop: "none",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                    }}
                    onClick={() => this.calculatorCollectionPoints(0)}
                  >
                    0
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      borderTop: "none",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() => this.calculatorCollectionPoints("b")}
                  >
                    X
                  </div>
                </div>
              </div>
            </Card>
            <Form.Item>
              <Button
                onClick={this.colModalOkHandler}
                loading={this.state.collectionBtnLoader}
                disabled={
                  this.props.form.getFieldValue("collectPoints") == undefined ||
                  this.props.form.getFieldValue("collectPoints") <
                    JSON.parse(localStorage.getItem("branch_data")).minPoint ||
                  this.props.form.getFieldValue("collectPoints") >
                    this.state.customer_col_points
                    ? true
                    : false
                }
                className="signup-form-button btnSpacing"
                htmlType="submit"
                size="large"
                block
              >
                {this.props.lang.BUTTON.SUBMIT}
              </Button>
            </Form.Item>
          </Modal>
        )}
        {this.state.isCashGivenModal && (
          <Modal
            title={PAYMENT_SCREEN.LABELS.USE_CASH_GIVEN_MODAL_TITLE}
            className="coupon-modal"
            visible={this.state.isCashGivenModal}
            onCancel={() =>
              this.setState({ isCashGivenModal: false }, () => {
                document.getElementById("root").classList.remove("blurClass");
              })
            }
            onOk={() => {
              this.cashGivenModalHandler();
            }}
            footer={false}
          >
            <h3 className="cal_amount" style={{ textAlign: "center" }}>
              {this.state.cashGiven}
            </h3>
            <Card>
              <div style={{ width: "100%", height: "70%", margin: "0 auto" }}>
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div
                    className="posButton  calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                    }}
                    onClick={() => this.calculatorFunctioncashGiven(1)}
                  >
                    1
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                    }}
                    onClick={() => this.calculatorFunctioncashGiven(2)}
                  >
                    2
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() => this.calculatorFunctioncashGiven(3)}
                  >
                    3
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                      borderTop: "none",
                    }}
                    onClick={() => this.calculatorFunctioncashGiven(4)}
                  >
                    4
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      borderTop: "none",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                    }}
                    onClick={() => this.calculatorFunctioncashGiven(5)}
                  >
                    5
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      borderTop: "none",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() => this.calculatorFunctioncashGiven(6)}
                  >
                    6
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                      borderTop: "none",
                    }}
                    onClick={() => this.calculatorFunctioncashGiven(7)}
                  >
                    7
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      borderTop: "none",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                    }}
                    onClick={() => this.calculatorFunctioncashGiven(8)}
                  >
                    8
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      borderTop: "none",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() => this.calculatorFunctioncashGiven(9)}
                  >
                    9
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                      borderTop: "none",
                    }}
                    onClick={() => this.calculatorFunctioncashGiven("c")}
                  >
                    C
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      borderTop: "none",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                    }}
                    onClick={() => this.calculatorFunctioncashGiven(0)}
                  >
                    0
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      borderTop: "none",
                      width: "100%",
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() => this.calculatorFunctioncashGiven("b")}
                  >
                    X
                  </div>
                </div>
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      flexGrow: 1,
                      flexShrink: 2,
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                      borderTop: "none",
                    }}
                    onClick={() => this.calculatorFunctioncashGiven(".")}
                  >
                    .
                  </div>
                  <div
                    className="posButton calculatorPayButton"
                    style={{
                      border: "1px solid #000",
                      width: "100%",
                      flexGrow: 2,
                      height: "100%",
                      textAlign: "center",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRight: "none",
                      borderTop: "none",
                    }}
                    onClick={this.cashGivenModalHandler}
                  >
                    {this.props.lang.BUTTON.PAY}
                  </div>
                </div>
              </div>
            </Card>
            <Form.Item>
              {/* <Button loading={this.state.couponBtnLoader}  className="signup-form-button btnSpacing"  onClick={this.cashGivenModalHandler} size="large" block >Pay</Button> */}
            </Form.Item>
          </Modal>
        )}
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    posStorage: state.posStorage,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    posStorageAction: (payload) => dispatch(posStorageAction(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(Form.create()(Payment));
